module.exports = __webpack_public_path__ + "968f329b.png";